import { __extends } from "tslib";
import { deserializeAws_json1_1ImportTerminologyCommand, serializeAws_json1_1ImportTerminologyCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ImportTerminologyCommand = /** @class */ (function (_super) {
    __extends(ImportTerminologyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ImportTerminologyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ImportTerminologyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ImportTerminologyCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1ImportTerminologyCommand(input, context);
    };
    ImportTerminologyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1ImportTerminologyCommand(output, context);
    };
    return ImportTerminologyCommand;
}($Command));
export { ImportTerminologyCommand };
//# sourceMappingURL=ImportTerminologyCommand.js.map